import script from "./Yuanqu.vue?vue&type=script&setup=true&lang=js"
export * from "./Yuanqu.vue?vue&type=script&setup=true&lang=js"

import "./Yuanqu.vue?vue&type=style&index=0&id=5a5bd518&lang=less&scoped=true"
script.__scopeId = "data-v-5a5bd518"

export default script